import axiosInstance from './axiosInstance';

/**
 * Normalise home-categories payloads from either the dedicated endpoint or UiConfig.
 * Expected item shape: { code, label, order, visible, iconUrl }
 */
export const extractHomeCategoryItems = (payload) => {
  if (!payload) return [];

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload.items)) {
    return payload.items;
  }

  if (Array.isArray(payload.config?.items)) {
    return payload.config.items;
  }

  // UiConfig rows occasionally nest under config.customConfig
  if (Array.isArray(payload.config?.customConfig?.items)) {
    return payload.config.customConfig.items;
  }

  return [];
};

/**
 * Preferred: GET ui/home-categories?country={code}
 * Fallback: GET ui/config/{country}?code=HOME_CATEGORIES → config.items
 */
export const fetchHomeCategories = async (country) => {
  const code = String(country || '').toUpperCase();
  if (!code) {
    return [];
  }

  try {
    const res = await axiosInstance.get('ui/home-categories', {
      params: { country: code },
    });
    const items = extractHomeCategoryItems(res?.data);
    if (items.length > 0) {
      return items;
    }
  } catch (error) {
    // 404 / missing route → fall through to UiConfig
    if (error?.response?.status && error.response.status !== 404) {
      // Non-404 failures still try UiConfig before giving up
    }
  }

  try {
    const res = await axiosInstance.get(`ui/config/${code}`, {
      params: { code: 'HOME_CATEGORIES' },
    });
    return extractHomeCategoryItems(res?.data);
  } catch (error) {
    return [];
  }
};
